// useAutoRefresh.js
import { useEffect, useState, useRef } from "react";

export default function useAutoRefresh(intervalMs = 60000) {
    const [updateAvailable, setUpdateAvailable] = useState(false);
    const currentVersion = useRef(null);

    useEffect(() => {
        const checkVersion = async () => {
            try {
                const res = await fetch(`/version.json?_=${Date.now()}`, { cache: "no-store" });
                const data = await res.json();

                if (currentVersion.current === null) {
                    currentVersion.current = data.version;
                    return;
                }

                if (data.version !== currentVersion.current) {
                    setUpdateAvailable(true);
                }
            } catch (err) {
                console.error("Version check failed", err);
            }
        };

        checkVersion();
        const id = setInterval(checkVersion, intervalMs);

        const onVisible = () => {
            if (document.visibilityState === "visible") checkVersion();
        };
        document.addEventListener("visibilitychange", onVisible);

        return () => {
            clearInterval(id);
            document.removeEventListener("visibilitychange", onVisible);
        };
    }, [intervalMs]);

    const reloadNow = () => window.location.reload();

    return { updateAvailable, reloadNow };
}